export const mapDropdownOptions = (options: any[]) => {
  return options.map((item: any) => ({
    id: item?.id,
    value: item.name || "",
    label: item.name || "",
  }));
};

export const mapOptionsToArray = (options: any[]) => {
  return options.map((item: any) => item.id);
};